module.exports = __webpack_public_path__ + "img/zlzs.cc8d16c7.png";